module.exports = __webpack_public_path__ + "static/img/Permiso(20).662cb5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(20).jpg
// module id = ecQv
// module chunks = 0